import { AngularFirestore, sortedChanges } from "@angular/fire/compat/firestore";
import { Injectable } from "@angular/core";
import { ConfigService } from "src/app/shared/config";
import { combineAll, map, switchMap } from "rxjs/operators";
import { combineLatest, of } from "rxjs";
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { SystemService } from "./system.service";

@Injectable({ providedIn: 'root' })
export class ScheculedTaskService {


    constructor(private afs: AngularFirestore,
        private config: ConfigService,
        private systemService: SystemService
    ) {
        // this.transferDocs()

    }



    getAllTasks() {

        return this.afs.collection('tasks').snapshotChanges().pipe(map(doc => {
            return doc.map(obj => {

                return {
                    ...obj.payload.doc.data() as object,
                    ...obj.payload.doc.data()['options'],
                    dbid: obj.payload.doc.id,
                    lastPerformed: obj.payload.doc.data()['time'] ? moment(obj.payload.doc.data()['time'].toDate()).format('HH:mm , DD-MM-YYYY') : "Not performed",
                    color: obj.payload.doc.data()['status'] == "complete" ? "GREEN" : "RED",
                    performAt: moment.unix(obj.payload.doc.data()['performAt']).format('HH:mm , DD-MM-YYYY')
                }
            })
        }))

    }

    getAllTasksData() {
        let array = []
        this.afs.collection('tasks').get().subscribe(doc => {

            doc.forEach(async obj => {
                console.log("data", obj.data())

                const element = obj.data();
                let unixTime = 0;
                let minute = 0
                let utc = 0;

                if (element['setMinutes']) {
                    minute = element['setMinutes'];
                    unixTime = moment().hour(Number(element['setHour']) - utc).minute(minute).unix();
                } else
                    unixTime = moment().hour(Number(element['setHour']) - utc).minute(minute).unix();
                if (element['renewalMonthly'])
                    unixTime = moment().endOf('month').hour(Number(element['setHour']) - utc).unix();
                // d.setMinutes(0);

                await this.systemService.updateTask(obj.id, {
                    status: 'scheduled',
                    performAt: unixTime
                });

            })
        })

    }

    // Root groups keyed by doc id (= task options.groupId), so each renewal row
    // can show which group it renews and flag a task stamped with another company.
    getGroupsMap() {
        return this.afs.collection('groups').get().pipe(map(snap => {
            const m: { [id: string]: any } = {};
            snap.docs.forEach(d => m[d.id] = d.data());
            return m;
        }));
    }

    getCombined() {
        return combineLatest(this.getAllTasks(), this.getAllMapping(), this.getGroupsMap()).pipe(map(data => {
            const groups = data[2];
            return data[0].map(doc => {
                const group = doc['groupId'] ? groups[doc['groupId']] : null;
                let finder = data[1].find((doc1) => {

                    if (doc1['systemId'] && doc['systemId'])
                        return doc1['systemId'] == doc['systemId']
                    else if (doc1['siteId'] && doc['siteId'])
                        return doc1['siteId'] == doc['siteId']
                    else
                        return {...doc,systemId:"Not Available",siteId : "Not Available",localSystemId:"notAvaialble"}
                });
                // console.log(doc)
                // console.log(finder)
                if (doc['name'] || finder['dbid'])
                    doc.name = doc['name'] ? doc['name'] : (finder['localSystemId']?finder['localSystemId'] : finder['dbid']);
                else
                    doc.name = doc.dbid
                let groupCheck = '';
                if (doc['groupId'] && /^creditRenew/.test(doc['worker'] || '')) {
                    if (!group || group.deleted) groupCheck = 'Group missing';
                    else if (group.companyId !== doc['companyId'] || group.siteId !== doc['siteId']) groupCheck = 'Wrong company/site';
                    else groupCheck = 'OK';
                }
                // The system lookup only supplies company/site names — task fields
                // (name, companyId, siteId) must win, or every row at a site shows
                // the first system's name.
                return {
                    ...finder, ...doc,
                    groupName: group ? group.name : '',
                    groupKey: group ? group.groupId : (doc['groupId'] || ''),
                    groupCheck
                }

            })
        }))
    }

    getAllMapping() {

        return this.afs.collection('system_info').snapshotChanges().pipe(
            switchMap(docs => {
                const systems = docs.map(doc => {
                    const d = doc.payload.doc.data() as any;
                    return {
                        ...d,
                        systemId: doc.payload.doc.id,
                        localSystemId: d.systemId || doc.payload.doc.id,
                    };
                });

                if (!systems.length) return of([[], [], []] as [any[], any[], any[]]);

                const companyIds = [...new Set(systems.map(s => s.companyId).filter(Boolean))];
                const siteKeys = [...new Set(systems.filter(s => s.companyId && s.siteId).map(s => `${s.companyId}::${s.siteId}`))];

                const companyDocs$ = companyIds.length
                    ? combineLatest(companyIds.map(id => this.afs.collection('company').doc(id).get()))
                    : of([]);
                const siteDocs$ = siteKeys.length
                    ? combineLatest(siteKeys.map(key => {
                        const [companyId, siteId] = key.split('::');
                        return this.afs.collection('company').doc(companyId).collection('sites').doc(siteId).get();
                    }))
                    : of([]);

                return combineLatest([of(systems), companyDocs$, siteDocs$]).pipe(map(([sys, companyDocs, siteDocs]) => {
                    const companyNameById = new Map(companyDocs.map((d: any) => [d.id, d.data()?.['name']]));
                    const siteNameByKey = new Map(siteKeys.map((key, i) => [key, (siteDocs[i] as any)?.data()?.['name']]));

                    return sys.map(s => ({
                        ...s,
                        companyName: companyNameById.get(s.companyId),
                        siteName: s.companyId && s.siteId ? siteNameByKey.get(`${s.companyId}::${s.siteId}`) : undefined,
                    }));
                }));
            })
        )




    }

    deleteTask(id) {
        console.log("id", id)
        this.afs.collection('tasks').doc(id).delete().then(data => console.log).catch(err => console.log)
    }





}